import {createSelector, createSlice, PayloadAction} from '@reduxjs/toolkit';
import type {AppState} from 'store/customer/storeSetup';

interface RunnerState {
    [key: string]: boolean;
}

export interface FaceHeightError {
    fields: string[];
    message: string;
}

export interface DrawerRunnerState {
    runnersLoadingState: RunnerState;
    // a typed face height held back for not fitting; it is not in the form, so
    // validation would never see it, and the product must not save past it
    faceHeightErrors: FaceHeightError[];
}

const initialState: DrawerRunnerState = {
    runnersLoadingState: {},
    faceHeightErrors: [],
};

const DrawerRunnerSlice = createSlice({
    name: 'drawerRunner',
    initialState,
    reducers: {
        setRunnersLoadingState: (
            state,
            {payload}: PayloadAction<RunnerState>
        ) => {
            state.runnersLoadingState = payload;
        },
        setFaceHeightErrors: (
            state,
            {payload}: PayloadAction<FaceHeightError[]>
        ) => {
            // none to none is no change, or validation reruns for nothing
            if (payload.length || state.faceHeightErrors.length) {
                state.faceHeightErrors = payload;
            }
        },
    },
});

export const selectRunnersLoadingState = createSelector(
    [(store: AppState) => store.drawerRunner.runnersLoadingState],
    (runnersLoadingState) => {
        return Object.entries(runnersLoadingState).some(
            (runner) => !!runner[1]
        );
    }
);

export const selectFaceHeightErrors = (store: AppState) =>
    store.drawerRunner.faceHeightErrors;

export const {setRunnersLoadingState, setFaceHeightErrors} =
    DrawerRunnerSlice.actions;
export default DrawerRunnerSlice.reducer;
